import {makeAutoObservable, transaction} from "mobx";
import {LoginInfoEntity} from "../entity/login-info-entity";
import {ColumnsType} from "antd/es/table";
import {getMenuList, getUserInfoList} from "../http/manager";
import {UserOperationType} from "../entity/enum/manager";
import {PageEntity} from "../entity/page-entity";
import {MenuInfoEntity} from "../entity/menu-info-entity";
import {Simulate} from "react-dom/test-utils";
import select = Simulate.select;

export class UserStore {

    constructor() {
        makeAutoObservable(this);
    }


    public userList: LoginInfoEntity[] | undefined;
    public columns: ColumnsType<LoginInfoEntity> | undefined
    public tabItems: any[] = [
        {key: "all", label: "全部"},
        {key: "online", label: "已启用"},
        {key: "offline", label: "已停用"},
    ];
    public condition = this.getDefaultCondition();
    public selectRows: LoginInfoEntity[] = [];
    public isUserOperationModal: boolean = false;
    public userType: string = UserOperationType.ADD;
    public useEditInfo: LoginInfoEntity = new LoginInfoEntity();
    public pagination: PageEntity = new PageEntity();
    public menuInfoList: MenuInfoEntity[] | undefined
    public count: number = 0
    public menuKey: string[] = []
    public isShowDeleteConfirm: boolean = false
    public userRecord: LoginInfoEntity = new LoginInfoEntity()
    public deleteType = 1;
    public editModalShow: boolean = false;
    public changeInfo: LoginInfoEntity = new LoginInfoEntity();

    public setUserList(list: LoginInfoEntity[]) {
        this.userList = list
    }

    public setColumns(columns: ColumnsType<LoginInfoEntity>) {
        this.columns = columns
    }

    public setTabItems(items: any[]) {
        this.tabItems = items
    }

    public setUseOperationModal(isShow: boolean) {
        this.isUserOperationModal = isShow
    }

    public setUseOperationType(type: UserOperationType) {
        this.userType = type
    }

    public setUseEditInfo(info: LoginInfoEntity) {
        this.useEditInfo = info
    }

    public setChangeInfo(info: LoginInfoEntity) {
        this.changeInfo = info
    }

    public setEditModalShow(isShow: boolean) {
        this.editModalShow = isShow
    }

    public getSelectMenuKey() {
        return this.menuKey.join(",");
    }

    public getMenuKey() {
        let result = ""
        this.menuInfoList?.forEach((item) => {
            const selectKey = this.menuKey.find((key) => {
                return item.key === key
            })
            if (selectKey) {
                result += item.key
            }
            item.children.forEach((child) => {

                const secondtKey = this.menuKey.find((key) => {
                    return child.key === key
                })
                if (secondtKey || selectKey) {
                    if (result) {
                        result = result + "," + child.key
                    } else {
                        result += child.key
                    }
                }

                child.children.forEach((third) => {
                    const selectChildKey = this.menuKey.find((key) => {
                        return third.key === key
                    })
                    if (selectKey || secondtKey) {
                        result = result + "," + third.key
                    } else if (selectChildKey) {
                        if (!result.includes(child.key)) {
                            if (result) {
                                result = result + "," + child.key
                            } else {
                                result += child.key
                            }
                        }
                        result = result + "," + third.key
                    }
                })
            })
        })
        return result
    }

    public queryUserInfo(isClear = false) {
        const params = {
            state: this.condition.state,
            username: this.condition.username,
            useraccount: this.condition.useraccount,
            department: this.condition.department,
            pageNum: this.pagination.pageNum,
            pageSize: this.pagination.pageSize,
        }
        return getUserInfoList(params)
    }

    public queryMenuList() {
        getMenuList({})
            .then((res) => {
                transaction(() => {
                    this.menuInfoList = res && res.data ? res.data : []
                })
            }).catch((e) => {
            console.log("error:"+e.message)
        })
    }


    public getDefaultCondition() {
        return {
            state: "",
            username: "",
            useraccount: "",
            department: "",
        }
    }

    public resetQuery = () => {
        this.condition.useraccount = ""
        this.condition.username = ""
        this.condition.department = ""
    }

    public modalClear = () => {
        this.userType = UserOperationType.ADD
        this.useEditInfo = new LoginInfoEntity()
        this.menuKey = []
    }

    public clear = () => {
        this.selectRows = []
        this.condition = this.getDefaultCondition()
        this.tabItems = [
            {key: "all", label: "全部"},
            {key: "online", label: "已启用"},
            {key: "offline", label: "已停用"},
        ];
        this.userList = []
        this.columns = []
        this.isUserOperationModal = false;
        this.userType = UserOperationType.ADD;
        this.useEditInfo = new LoginInfoEntity()
        this.pagination = new PageEntity()
        this.menuInfoList = []
        this.count = 0
        this.menuKey = []
        this.userRecord = new LoginInfoEntity()
        this.deleteType = 1
    }
}